import logo from "./logo.svg";
import Home from "./Pages/Home/Home";

function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
